import * as React from 'react';
import { Alert, Typography } from '@mui/material';

export const TestConnectionAlert = ({ testResult }) => {
  if (!testResult) return null;

  return (
    <Alert 
      severity={testResult.is_connected ? "success" : "error"} 
      sx={{ marginTop: '1rem' }}
    >
      <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
        {testResult.message}
      </Typography>
      {testResult.detail && (
        <Typography variant="caption" sx={{ display: 'block', mt: 0.5 }}>
          {testResult.detail}
        </Typography>
      )}
    </Alert>
  );
};

